import { createTags } from "../../util/foodReview/extractData";

import FoodComments from "./FoodComments";
import TagsDisplay from "./TagsDisplay";
import { useState } from "react";

// Parent component -- FoodReviewPage
export default function FoodReviewComponent({ data, bId }) {
  //console.log("Food REview Component");
  //console.log(data);
  const tagData = createTags(data, bId);
  //console.log(tagData);

  //   //console.log(createTags(data));
  /**FORMAT of tag object
   * [{
   * mainId:"67343e6ecae7305cf911d8f1",
   * data : [{
   *      foodName: "Paneer tikka1",
          isArchived: false,
          foodIssue: "it was hard. not cooked well and blancd",
          feedback_id: "67343e6ecae7305cf911d8f1",
   * }]
   */
  // const dummyTagData = [
  //   {
  //     mainId: "67343e6ecae7305cf911d8f1",
  //     data: [
  //       {
  //         foodName: "Paneer tikka1",
  //         isArchived: true,
  //         foodIssue: "it was hard. not cooked well and blancd",
  //         feedback_id: "67343e6ecae7305cf911d8f1",
  //       },
  //     ],
  //   },
  //   {
  //     mainId: "67343e6ecae7305cf93d8f2",
  //     data: [
  //       {
  //         foodIssue: "it was hard. not cooked well and blancd",
  //         foodName: "Paneer tikka2",
  //         isArchived: false,
  //         feedback_id: "67343e6ecae7305cf911d8f2",
  //       },
  //     ],
  //   },

  //   {
  //     mainId: "67343e64305cf911d8f13",
  //     data: [
  //       {
  //         foodIssue: "it was hard. not cooked well and blancd",
  //         foodName: "Paneer tikka3",
  //         isArchived: false,
  //         feedback_id: "67343920cae7305cf911d87d",
  //       },
  //     ],
  //   },
  //   {
  //     mainId: "6733e6ecae7305cf911d8f14",
  //     data: [
  //       {
  //         foodIssue: "it was hard. not cooked well and blancd",
  //         foodName: "Paneer tikka4",
  //         isArchived: false,
  //         feedback_id: "67343e6ecae7305cf911d8f14",
  //       },
  //     ],
  //   },

  //   {
  //     mainId: "67343e6ec1cf911d8f13",
  //     data: [
  //       {
  //         foodIssue: "it was hard. not cooked well and blancd",
  //         foodName: "Paneer tikka5",
  //         isArchived: false,
  //         feedback_id: "67343e6ecae7305cf911d8f13",
  //       },
  //     ],
  //   },

  //   {
  //     mainId: "67343e625cf911d8f13",
  //     data: [
  //       {
  //         foodIssue:
  //           "it was hard. very bad experince no salt, not cooked well and blancd",
  //         foodName: "Paneer tikka6",
  //         isArchived: false,
  //         feedback_id: "67343e6ecae7305cf9311d8f13",
  //       },
  //     ],
  //   },

  //   {
  //     mainId: "67343e4e7305cf911d8f13",
  //     data: [
  //       {
  //         foodIssue:
  //           "it was hard. Did not like the taste at all not cooked well and blancd",
  //         foodName: "Paneer tikka7",
  //         feedback_id: "67343e6e3305cf911d8f13",
  //       },
  //     ],
  //   },

  //   {
  //     mainId: "67343e6ecae732911d8f13",
  //     data: [
  //       {
  //         foodIssue: "it was hard. not cooked well and blancd",
  //         foodName: "Paneer tikka8",
  //         feedback_id: "67343e6ecae7305cf911d8f13",
  //       },
  //     ],
  //   },
  // ];

  const [tagsData, setTagsData] = useState(tagData);

  //console.log(tagsData);
  return (
    <>
      <TagsDisplay
        tagsContainer={tagsData}
        setTagsContainer={setTagsData}
        bId={bId}
      />
      <FoodComments data={tagsData} setTagsData={setTagsData} bId={bId} />
    </>
  );
}
